import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

export const settingsCustomFieldsProductsConfig = {
    all:  {
        title: 'custom_fields_product',
        icon: <PlaylistAddIcon/>,
        isSingleDataGrid: true,
    },
};
